<div class="w-full">
  <hoc-grouped-list
    [loading]="loading"
    [groupLetters]="groupLetters"
    [items]="items"
    [headerBlock]="headerBlock"
    [loadingBlock]="loadingBlock"
    [footerBlock]="footerBlock"
    [groupBlock]="groupBlock"
    [itemBlock]="itemBlock"
    [emptyItemsBlock]="emptyItemsBlock"
    (scrolledToEnd)="scrolledToEnd()">
  </hoc-grouped-list>
</div>

<ng-template #groupBlock let-letter>
  <h3 class="list-title-text">{{ letter }}</h3>
</ng-template>

<ng-template #loadingBlock>
  <app-list-placeholder [hasTitle]="true" [hasImageColumn]="true" [columnCount]="3" [lineCount]="2" />
</ng-template>

<ng-template #itemBlock let-item>
  <app-list-item [data]="getTeamListItem(item)" />
</ng-template>

<ng-template #emptyItemsBlock>
  <app-empty-details-list-page />
</ng-template>

<ng-template #footerBlock>
  <div #footerContainer class="px-3 py-4">
    <!-- TODO: Add a <gx-button>Load more</gx-button> also with infinite scroll. in case something is not working user has control!-->
    @if (loadMode === 'paged' && items.size > 0) {
      <gx-pagination
        [data]="pagination"
        (newPage)="gotoPage($event)"
        [availablePageSizes]="config.pageSizes"
        [currentPageSize]="filter.pageSize"
        [lengthBeginSegment]="4"
        [lengthEndSegment]="4"
        (newPageSize)="newPageSize($event)" />
    }

    @if (loadMode === 'infinite' && canLoadMore) {
      <app-list-placeholder [hasImageColumn]="true" [columnCount]="3" [lineCount]="2" (click)="scrolledToEnd()" />
    }
  </div>
</ng-template>

<ng-template #headerBlock>
  <div class="flex w-full justify-end">
    <gx-sorting-selector (directionChanged)="sortingChanged($event)" [direction]="sorting" />
  </div>
</ng-template>
